import { isModuleRestricted } from '@/guards/routeAccess';

export function allowedToShowItem(allowed, user, item) {
  let showItem = false;
  for (let allowedItem of allowed) {
    switch (allowedItem) {
      case 'no-user':
        if (user?.id) showItem = true;
        break;
      case 'user':
        if (user) showItem = true;
        break;
      case 'admin':
        if (user?.isAdmin) showItem = true;
        break;
      case 'salesAdmin':
        if (user?.isAdmin || user?.isSalesAdmin) showItem = true;
        break;
      case 'partner':
        if (user?.isAdmin || user?.isPartner) showItem = true;
        break;
      case 'restrict':
        if (!isModuleRestricted(user, item.path, item.handle.allowedConfig))
          showItem = true;
        break;
      case 'all':
        break;
      default:
        console.info(
          'Unsupported allowed value for route:',
          allowedItem,
          'Route:',
          item,
        );
    }
  }
  return showItem;
}
